import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import apiFetchBalanceModificationTransactionsCreate from '../../api/BalanceModificationTransactionCreateAPI';
import { BOH_TRANSACTIONS_CREATE_REQUEST } from '../actions/types/BalanceModificationTransactionsCreateActionsTypes';
import { postBOHTransactionsCreateSuccessActionCreator, postBOHTransactionsCreateFailureActionCreator } from '../actions/BalanceModificationTransactionsCreateActions';
import { showNotification } from '../../../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../../locales/locales';
import { languageSelector } from '../../../../../../../common/redux/selectors/languageSelector';

function* doBOHTransactionsCreateWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiFetchBalanceModificationTransactionsCreate, action.payload);
    yield put(postBOHTransactionsCreateSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.bohtransaction.create.success'),
    }));
  } catch (error) {
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'app.server.error'),
    }));
    yield put(postBOHTransactionsCreateFailureActionCreator(error));
  }
}

function* doBOHTransactionsCreateWatcher() {
  yield takeLatest(BOH_TRANSACTIONS_CREATE_REQUEST, doBOHTransactionsCreateWorker);
}

export default doBOHTransactionsCreateWatcher;
